// extracted by mini-css-extract-plugin
export default {"personallyKnownToNotaryWarning":"RX6DIB8Lzn_n6Aqg9PXX"};